// Template Dashboard 2 MUI Base Styles
import colors from "assets/theme-dark/base/colors";

const { background } = colors;

const dataGrid = {
  defaultProps: {},

  styleOverrides: {
    panelWrapper: {
      backgroundColor: background.default,
    },
    root: {
      "& .MuiDataGrid-row--editing .MuiDataGrid-cell": {
        backgroundColor: background.default,
      },
    },
  },
};

export default dataGrid;
